import React, { Component } from "react";
//import { ProgressSpinner } from "primereact/components/progressspinner/ProgressSpinner";
import { Button } from "primereact/components/button/Button";
import { Growl } from "primereact/components/growl/Growl";
import { Dropdown } from "primereact/components/dropdown/Dropdown";

//Imports from common
import { api } from "../../common/CloudService/ApiPromisify";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import { LoadScreen } from "../Common/LoadScreen";
//import { formatId } from "../../common/FormatId";

export class Business extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      test: "",
      businessEdited: false,
      businessAddressLine1: "",
      businessAddressLine2: "",
      businessName: "",
      businessCity: "",
      businessCodeTag: "",
      businessCountry: "",
      businessCountryCode: "",
      businessCurrency: "",
      businessCurrencyDecimalPlaces: "",
      businessCurrencySymbol: "",
      businessId: "",
      businessLastUpdatedDateTime: "",
      businessLicenceNumberOfUsers: "",
      businessPostalZipCode: "",
      businessTelephoneNumber: "",
      businessTimezone: "",
      editedBusinessName: "",
      editedBusinessLicenceNumberOfUsers: "",
      editedBusinessEmail: "",
      editedBusinessTelephoneNumber: "",
      editedBusinessAddressLine1: "",
      editedBusinessAddressLine2: "",
      editedBusinessPostalZipCode: "",
      editedBusinessCity: "",
      editedBusinessCountry: "",
      editedBusinessCurrency: ""
    };
  }

  componentDidMount() {
    this.getBusiness();
  }

  getBusiness = async () => {
    this.setState({ loaded: false });

    let businessRequest = new CloudService.BusinessRequest();
    businessRequest.codeTag = localStorage.getItem("codeTag");

    await api("businessApiV1BusinessAccountGet", businessRequest).then(res => {
      if (res.data.lastUpdatedDateTime !== undefined) {
        res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
      }

      let businessResponse = CloudService.BusinessResponse.constructFromObject(
        res.data
      );
      console.log(businessResponse);

      if (businessResponse.errorCode === 0) {
        this.setState({
          businessAddressLine1: businessResponse.addressLine1,
          businessAddressLine2: businessResponse.addressLine2,
          businessName: businessResponse.businessName,
          businessCity: businessResponse.city,
          businessCodeTag: businessResponse.codeTag,
          businessCountry: businessResponse.country,
          businessCountryCode: businessResponse.countryCode,
          businessCurrency: businessResponse.currency,
          businessCurrencyDecimalPlaces: businessResponse.currencyDecimalPlaces,
          businessCurrencySymbol: businessResponse.currencySymbol,
          businessId: businessResponse.id,
          businessLastUpdatedDateTime: businessResponse.lastUpdatedDateTime,
          businessLicenceNumberOfUsers: businessResponse.licenceNumberOfUsers,
          businessPostalZipCode: businessResponse.postalZipCode,
          businessTelephoneNumber: businessResponse.telephoneNumber,
          businessEmail: businessResponse.email,
          businessTimezone: businessResponse.timezone
        });
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error occured retrieving data, please refresh and try again",
          life: 3000
        });
      }
    });

    this.setState({ loaded: true });
  };

  editBusiness = async () => {
    this.setState({ loaded: false });

    let businessRequest = new CloudService.BusinessRequest();
    businessRequest.codeTag = localStorage.getItem("codeTag");
    businessRequest.lastUpdatedDateTime = this.state.businessLastUpdatedDateTime;
    if (this.state.editedBusinessName !== this.state.businessName) {
      businessRequest.businessName = this.state.editedBusinessName;
    }
    businessRequest.licenceNumberOfUsers = this.state.editedBusinessLicenceNumberOfUsers;
    businessRequest.email = this.state.editedBusinessEmail;
    businessRequest.telephoneNumber = this.state.editedBusinessTelephoneNumber;
    businessRequest.addressLine1 = this.state.editedBusinessAddressLine1;
    businessRequest.addressLine2 = this.state.editedBusinessAddressLine2;
    businessRequest.postalZipCode = this.state.editedBusinessPostalZipCode;
    businessRequest.city = this.state.editedBusinessCity;
    businessRequest.country = this.state.editedBusinessCountry;
    businessRequest.currency = this.state.editedBusinessCurrency;
    if (this.state.editedBusinessCurrency === "GBP") {
      businessRequest.currencySymbol = "£";
    } else if (this.state.editedBusinessCurrency === "EUR") {
      businessRequest.currencySymbol = "€";
    } else {
    }

    await api("businessApiV1BusinessUpdate", businessRequest).then(res => {
      let businessResponse = CloudService.BusinessResponse.constructFromObject(
        res.data
      );
      console.log(businessResponse);

      if (businessResponse.errorCode === 0) {
        this.setState({
          businessEdited: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Business successfully updated",
          life: 3000
        });
        this.getBusiness();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured updating the business, please try again",
          life: 3000
        });
      }
    });
  };

  render() {
    const currencyOptions = [
      { label: "Pound Sterling", value: "GBP" },
      { label: "Euro", value: "EUR" }
    ];

    return (
      <div className="ui-g dashboard">
        <Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />

        {this.state.loaded === false ? (
          <LoadScreen />
        ) : (
          <div className="ui-g-12">
            {/*Business Card*/}
            {this.state.businessEdited === true ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Business Name: </b>
                    <label>{this.state.businessName || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Licensed Number of Users: </b>
                    <label>
                      {this.state.businessLicenceNumberOfUsers || 0}
                    </label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Email Address: </b>
                    <label>{this.state.businessEmail || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Telephone: </b>
                    <label>
                      {this.state.businessTelephoneNumber || "Not Set"}
                    </label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Address Line 1: </b>
                    <label>
                      {this.state.businessAddressLine1 || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-6">
                    <b>Address Line 2: </b>
                    <label>
                      {this.state.businessAddressLine2 || "Not Set"}
                    </label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Postcode: </b>
                    <label>
                      {this.state.businessPostalZipCode || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-6">
                    <b>Town: </b>
                    <label>{this.state.businessCity || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Country: </b>
                    <label>{this.state.businessCountry || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Currency: </b>
                    <label>
                      {this.state.businessCurrency === "GBP"
                        ? "Pound Sterling"
                        : this.state.businessCurrency === "EUR"
                        ? "Euro"
                        : "Not Set"}
                    </label>
                  </div>
                </div>
                <div className="ui-g-12">
                  {localStorage.getItem("roleType") !== "10" ? (
                    <label />
                  ) : (
                    <Button
                      label="Edit"
                      onClick={() => {
                        this.setState({
                          businessEdited: true,
                          editedBusinessName: this.state.businessName,
                          editedBusinessLicenceNumberOfUsers: this.state
                            .businessLicenceNumberOfUsers,
                          editedBusinessEmail: this.state.businessEmail,
                          editedBusinessTelephoneNumber: this.state
                            .businessTelephoneNumber,
                          editedBusinessAddressLine1: this.state
                            .businessAddressLine1,
                          editedBusinessAddressLine2: this.state
                            .businessAddressLine2,
                          editedBusinessPostalZipCode: this.state.postalZipCode,
                          editedBusinessCity: this.state.businessCity,
                          editedBusinessCountry: this.state.businessCountry,
                          editedBusinessCurrency: this.state.businessCurrency
                        });
                      }}
                      style={{ float: "right" }}
                    />
                  )}
                  <Button
                    className="secondary-btn"
                    label="View Users"
                    onClick={() => {
                      window.location = "#/employees";
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Editing Business Card*/}
            {this.state.businessEdited === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        disabled={true}
                        className={
                          this.state.editedBusinessName === "" ||
                          this.state.editedBusinessName === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBusinessName || ""}
                        onChange={e =>
                          this.setState({
                            editedBusinessName: e.target.value
                          })
                        }
                      />
                      <label>Business Name</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        disabled={true}
                        className={
                          this.state.editedBusinessLicenceNumberOfUsers ===
                            "" ||
                          this.state.editedBusinessLicenceNumberOfUsers ===
                            undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={
                          this.state.editedBusinessLicenceNumberOfUsers || 0
                        }
                        onChange={e =>
                          this.setState({
                            editedBusinessLicenceNumberOfUsers: e.target.value
                          })
                        }
                      />
                      <label>Licensed Number of Users</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBusinessEmail === "" ||
                          this.state.editedBusinessEmail === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBusinessEmail || ""}
                        onChange={e =>
                          this.setState({
                            editedBusinessEmail: e.target.value
                          })
                        }
                      />
                      <label>Email Address</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBusinessTelephoneNumber === "" ||
                          this.state.editedBusinessTelephoneNumber === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBusinessTelephoneNumber || ""}
                        onChange={e =>
                          this.setState({
                            editedBusinessTelephoneNumber: e.target.value
                          })
                        }
                      />
                      <label>Telephone</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBusinessAddressLine1 === "" ||
                          this.state.editedBusinessAddressLine1 === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBusinessAddressLine1 || ""}
                        onChange={e =>
                          this.setState({
                            editedBusinessAddressLine1: e.target.value
                          })
                        }
                      />
                      <label>Address Line 1</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBusinessAddressLine2 === "" ||
                          this.state.editedBusinessAddressLine2 === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBusinessAddressLine2 || ""}
                        onChange={e =>
                          this.setState({
                            editedBusinessAddressLine2: e.target.value
                          })
                        }
                      />
                      <label>Address Line 2</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBusinessPostalZipCode === "" ||
                          this.state.editedBusinessPostalZipCode === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBusinessPostalZipCode || ""}
                        onChange={e =>
                          this.setState({
                            editedBusinessPostalZipCode: e.target.value
                          })
                        }
                      />
                      <label>Postcode</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBusinessCity === "" ||
                          this.state.editedBusinessCity === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBusinessCity || ""}
                        onChange={e =>
                          this.setState({
                            editedBusinessCity: e.target.value
                          })
                        }
                      />
                      <label>Town</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBusinessCountry === "" ||
                          this.state.editedBusinessCountry === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBusinessCountry || ""}
                        onChange={e =>
                          this.setState({
                            editedBusinessCountry: e.target.value
                          })
                        }
                      />
                      <label>Country</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <label style={{ color: "grey" }}>&nbsp;Currency</label>
                    <br />
                    <Dropdown
                      value={this.state.editedBusinessCurrency}
                      options={currencyOptions}
                      onChange={e => {
                        this.setState({
                          editedBusinessCurrency: e.value
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="ui-g-12">
                  <Button
                    label="Save"
                    onClick={() => {
                      this.editBusiness();
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    label="Cancel"
                    onClick={() => {
                      this.setState({
                        businessEdited: false
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Business/Business.js